var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    className: "sc-f7f22ea2-1 jQiTXm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_search_svg__painted",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.891 2.09c2.619.317 4.79 2.393 5.23 4.996a6.077 6.077 0 0 1-1.092 4.629l-.15.194-.136.163-.035-.012.077.05.07.061 4.125 4.125a.667.667 0 0 1-.868 1.007l-.075-.064-4.124-4.125c-.058-.058-.104-.125-.074-.182a6.067 6.067 0 0 1-4.753 1.19c-2.603-.44-4.679-2.612-4.997-5.23a6.086 6.086 0 0 1 6.802-6.803Zm-.786 1.119a4.897 4.897 0 1 0 0 9.794 4.897 4.897 0 0 0 0-9.794Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.26e8d527dd0470e5e6f00e0eaaee4395.svg";
export { ForwardRef as ReactComponent };